import { IReportingState } from '@/modules/reporting/store/state';
import { MutationTree } from 'vuex';
import * as MT from './mutationsTypes';
import { GeneratedReportDetails, Report, Notes, QueuedReport } from '../types';
import Investment from '../../../models/Investment';
import { Fund } from '../../fund/types';
import { PensionScheme } from '@/modules/pensionScheme/types';
import { AnalysisPensionScheme } from '../../costAnalysis/types';
import { SubFund } from '../../subFund/types';
import TimePeriod from '../../../models/TimePeriod';
/*--------------------------------------------------/
 * Cost Analysis Mutations
 *--------------------------------------------------*/
export const ReportingMutations: IReportingMutations = {
  [MT.SET_LOADING_REPORT_DATA]: (
    state: IReportingState,
    loadingReportData: boolean
  ) => (state.loadingReportData = loadingReportData),

  [MT.SET_REPORT_HTML]: (state: IReportingState, rawHtml: string) =>
    (state.rawHtml = rawHtml),

  [MT.SET_PLAN_TYPE]: (state: IReportingState, planType: string) =>
    (state.planType = planType),

  [MT.SET_REPORT_SUB_TYPE]: (state: IReportingState, reportSubType: string) =>
    (state.reportSubType = reportSubType),

  [MT.SET_REPORT_REPORTING_PERIOD]: (
    state: IReportingState,
    selectedReportingPeriod: TimePeriod
  ) => (state.selectedReportingPeriod = selectedReportingPeriod),

  [MT.SET_ORGANISATION_EXPORT]: (
    state: IReportingState,
    isOrganisationWideExport: boolean
  ) => (state.isOrganisationWideExport = isOrganisationWideExport),

  [MT.SET_REPORT_PENSION_SCHEMES]: (
    state: IReportingState,
    reportPensionSchemes: Fund[]
  ) => (state.reportPensionSchemes = reportPensionSchemes),

  [MT.SET_SELECTED_REPORT_CLIENT]: (
    state: IReportingState,
    selectedReportClient: AnalysisPensionScheme | SubFund
  ) => (state.selectedReportClient = selectedReportClient),

  [MT.SET_REPORT_COMMENTS]: (state: IReportingState, comments: Notes[]) =>
    (state.comments = comments),

  [MT.SET_GENERATED_REPORT_DETAILS]: (
    state: IReportingState,

    generatedReportDetails: GeneratedReportDetails
  ) => (state.generatedReportDetails = generatedReportDetails),
  [MT.SET_REPORTS]: (state: IReportingState, reports: Report[]) =>
    (state.reports = reports),
  [MT.SET_EXPOSED_SUB_FUNDS]: (
    state: IReportingState,
    exposedSubFunds: SubFund[]
  ) => (state.exposedSubFunds = exposedSubFunds),
  [MT.SET_SCHEMES_HAVING_EXPOSED_SUBFUNDS]: (
    state: IReportingState,
    schemes: PensionScheme[]
  ) => (state.schemesHavingExposedSubFunds = schemes),
  [MT.SET_QUEUED_REPORTS]: (
    state: IReportingState,
    queuedReports: QueuedReport[]
  ) => (state.queuedReports = queuedReports)
};

/*--------------------------------------------------/
 * Cost Analysis Mutations Tree Interface
 *--------------------------------------------------*/
export interface IReportingMutations extends MutationTree<IReportingState> {
  [MT.SET_LOADING_REPORT_DATA](
    state: IReportingState,
    loadingReportData: boolean
  ): void;
  [MT.SET_REPORT_HTML](state: IReportingState, rawHtml: string): void;
  [MT.SET_PLAN_TYPE](state: IReportingState, planType: string): void;
  [MT.SET_REPORT_SUB_TYPE](state: IReportingState, reportSubType: string): void;
  [MT.SET_REPORT_REPORTING_PERIOD](
    state: IReportingState,
    selectedReportingPeriod: TimePeriod
  ): void;
  [MT.SET_ORGANISATION_EXPORT](
    state: IReportingState,
    isOrganisationWideExport: boolean
  ): void;
  [MT.SET_REPORT_COMMENTS](state: IReportingState, comments: Notes[]): void;
  [MT.SET_REPORT_PENSION_SCHEMES](
    state: IReportingState,
    reportPensionSchemes: Fund[]
  ): void;
  [MT.SET_SELECTED_REPORT_CLIENT](
    state: IReportingState,
    selectedReportClient: AnalysisPensionScheme | SubFund
  ): void;
  [MT.SET_GENERATED_REPORT_DETAILS](
    state: IReportingState,
    generatedReportDetails: GeneratedReportDetails
  ): void;
  [MT.SET_REPORTS](state: IReportingState, reports: Report[]): void;
  [MT.SET_SCHEMES_HAVING_EXPOSED_SUBFUNDS](
    state: IReportingState,
    schemes: PensionScheme[]
  ): void;
  [MT.SET_QUEUED_REPORTS](
    state: IReportingState,
    queuedReports: QueuedReport[]
  ): void;
}
